import { useContext } from 'react'
import RolePicker from 'Components/reusable/InputFields/RolePicker'
import { IAssignmentRole } from 'types/assignmentInterfaces'
import { AssignmentRoleId } from 'types/ids'
import { Context } from '../context'
import { AnyObject, ContextValue, EditableFieldsOfType } from '../types'

/**
 * Person picker.
 */
export const DataEditContextRoleField = <T extends AnyObject>({
  field,
  assignmentRoles,
  dataField,
  showNames,
  insetLabel,
  ...rest
}: {
  assignmentRoles: IAssignmentRole[]
  field: EditableFieldsOfType<T, AssignmentRoleId | null>
  dataField: EditableFieldsOfType<T, IAssignmentRole | null>
  showNames: boolean
  insetLabel?: boolean
} & Omit<Record<string, unknown>, 'onChange' | 'value' | 'error' | 'name'>) => {
  const { flatData, disabled, setFields, localeBase, t } = useContext<ContextValue<T>>(Context)

  const handleChange = (newValue: IAssignmentRole | null) => {
    setFields({ [field]: newValue?.id ?? null, [dataField]: newValue })
  }

  const dataValue = flatData[dataField] as unknown as IAssignmentRole

  return (
    <RolePicker
      onChange={handleChange}
      disabled={disabled[field] ?? false}
      value={dataValue ?? null}
      label={t(`${localeBase}.${field}`)}
      assignmentRoles={assignmentRoles}
      showNames={showNames}
      insetLabel={insetLabel}
      {...rest}
    />
  )
}

/**
 * State picker.
 */
